import templateManager, { Template } from "../component/widgets/TemplateManager"
import FundSharePerformances from "./FundSharePerformances"
import FundSummaryTitle from "./FundSummaryTitle"
import FundSummaryDescription from "./FundSummaryDescription"

/**
 * Template for Montaigne Home Page
 * @type {Template}
 */
const fundSharePerf = Template.of(FundSharePerformances, {})

const fundSummaryTitle = Template.of(FundSummaryTitle, {})
const fundSummaryDescription = Template.of(FundSummaryDescription, {})

templateManager.registerTemplate("fund_share_performance", fundSharePerf)
templateManager.registerTemplate("fund_summary_title", fundSummaryTitle)
templateManager.registerTemplate(
  "fund_summary_description",
  fundSummaryDescription
)
